<script>
export default {
  components: {},
  props: {
    FetchingStudents: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>

<template>
  <div class="col-12">
    <b-card no-body class="mb-1 shadow-none">
      <b-card-header header-tag="header" role="tab">
        <h6 class="m-0">
          <a
            v-b-toggle.accordion-1
            class="text-primary"
            href="javascript: void(0);"
            ><u> Click to Filter Students</u>
            <i class="fa fa-filter" aria-hidden="true"></i
          ></a>
        </h6>
      </b-card-header>
      <b-collapse
        id="accordion-1"
        visible
        accordion="my-accordion"
        role="tabpanel"
      >
        <b-card-body>
          <slot>Customm</slot>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>